import e from "./toPropertyKey.js";
//#region \0@oxc-project+runtime@0.142.0/helpers/esm/defineProperty.js
function t(t, n, r) {
	return (n = e(n)) in t ? Object.defineProperty(t, n, {
		value: r,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : t[n] = r, t;
}
//#endregion
export { t as default };
